import { render, staticRenderFns } from "./CoViewPublicEventList.vue?vue&type=template&id=05fbf8eb&"
import script from "./CoViewPublicEventList.vue?vue&type=script&lang=ts&"
export * from "./CoViewPublicEventList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports